/**
 * Marker for requests the admin did not ask for — sidebar badges, unread
 * counters, and other polls that run on their own.
 *
 * A 403 on one of these means "this admin's role does not include that
 * feature", not "this session is no longer valid". The global response
 * interceptor tears the session down on a 403 from the admin host, which is
 * right for something the admin clicked and wrong for a background poll: it
 * would drop them at the login screen for a badge they never requested.
 */
export const SKIP_SESSION_INVALIDATION = "skipSessionInvalidation"

export function backgroundRequestConfig(config = {}) {
  return { ...config, [SKIP_SESSION_INVALIDATION]: true }
}

export function isBackgroundRequest(config) {
  return Boolean(config && config[SKIP_SESSION_INVALIDATION])
}
